var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "grid grid--column grid--ai-middle grid--jc-middle mg mg--t-15 mg--b-15"
    },
    [
      _c("svgicon", {
        attrs: { name: _vm.icon, height: "100", width: "100", color: "#005BA5" }
      }),
      _c("p", { staticClass: "headline-medium mg mg--b-2" }, [
        _vm._v(_vm._s(_vm.title))
      ]),
      _c("p", { staticClass: "text-medium" }, [_vm._v(_vm._s(_vm.descr))])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }